"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memberGroups = void 0;
var utils_1 = require("../../utils");
exports.memberGroups = function (axios) {
    return {
        getMemberGroups: function (request) {
            return axios.get('/member-groups', request);
        },
        postMemberGroups: function (request) {
            return axios.post('/member-groups', request.data);
        },
        putMemberGroups: function (request) {
            return axios.put('/member-groups', request.data);
        },
        deleteMemberGroups: function (request) {
            return axios.delete('/member-groups', request);
        },
        getMemberGroupsGroupNo: function (request) {
            var url = utils_1.paramPathchange('/member-groups/{groupNo}', request);
            return axios.get(url, request);
        },
        putMemberGroupsGroupNo: function (request) {
            var url = utils_1.paramPathchange('/member-groups/{groupNo}', request);
            return axios.put(url, request.data);
        },
        deleteMemberGroupsGroupNo: function (request) {
            var url = utils_1.paramPathchange('/member-groups/{groupNo}', request);
            return axios.delete(url);
        },
        putMemberGroupsGroupNoOrder: function (request) {
            var url = utils_1.paramPathchange('/member-groups/{groupNo}/order', request);
            return axios.put(url, request.data);
        }
    };
};
